import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';
import { AlertaSimplesDialog } from '../alerta-simples';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import {BaseNotificacao} from '../tamas-models';
import * as moment from 'moment';

@Component({
  selector: 'app-me-notificacao',
  templateUrl: './me-notificacao.component.html',
  styleUrls: ['./me-notificacao.component.css']
})
export class MeNotificacaoComponent implements OnInit {
  hideCL: boolean = false;
  tipoNotificacao: any = '';
  idNotificacao: any = '';
  dh: any = '';
  urlFoto: any = '';
  nickPro: any = '';
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router, public tmaService: TamasAlunoService, public dialog: MatDialog) { }

  ngOnInit() {
    this.hideCL = true;
    this.tipoNotificacao = this.route.snapshot.paramMap.get('tipo');
    this.idNotificacao = this.route.snapshot.paramMap.get('idnotificacao');
    //this.urlFoto = 'https://tamasappcdn.s3.sa-east-1.amazonaws.com/ecommerce/banners/';
    this.urlFoto = this.tmaService.urlRepositorioS3 + "/ecommerce/banners/";
    this.getNotify();
  }

  getNotify() :void{
    console.log("call");
    this.hideCL = false;
    var gDados = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&tipo=' + this.tipoNotificacao + '&id=' + this.idNotificacao;
    this.tmaService.infoNotificacao(gDados)
    .subscribe((qRes) =>{
      console.log(qRes);
      this.hideCL = true;
      if(qRes['res'] == 'done'){
        this.dh = qRes['dados'];
        this.nickPro = qRes['nick'];
      }
    });
  }

  goPromo() :void{
    console.log(this.dh.Destino);
    if (localStorage.getItem("tmsGeoLoja") !== null) {
      var dadosGL = [];
      dadosGL = JSON.parse(localStorage.getItem('tmsGeoLoja'));
      this.tmaService.shopUF = dadosGL['uf'];
      this.tmaService.shopCidade = dadosGL['cidade'];
      this.router.navigate(['shopping/' + dadosGL['uf'] + '/' + dadosGL['cidade'] + '/'+ this.dh.Destino]);

      //this.router.navigate(['shop/' + dadosGL['uf'] + '/' + dadosGL['cidade']], {replaceUrl: true});
    }
    else{
      //ainda não visitou o shopping
     
      this.tmaService.glDestinoCampanha = this.dh.Destino;
      this.router.navigate(['/pre-shop/uf']);
    }
   

  }

  goCart() :void{
    if (localStorage.getItem("tmsGeoLoja") !== null) {
      var dadosGL = [];
      dadosGL = JSON.parse(localStorage.getItem('tmsGeoLoja'));
      this.tmaService.shopUF = dadosGL['uf'];
      this.tmaService.shopCidade = dadosGL['cidade'];
      this.router.navigate(['/shopping/carrinho']);
    }
    else{
      this.tmaService.glDestinoCampanha = 'carrinho';
      this.router.navigate(['/pre-shop/uf']);
    }

  }

  goAvaliacao() :void{
    this.router.navigate(['/me/avaliacao/' + this.dh.IdPlano]);
  }

  goAvaliar() :void{
    this.tmaService.paginaAnterior = 'me/notificacoes';
    this.router.navigate(['/shopping/avaliar/' + this.dh.IdPedido]);
  }


  goPedido() :void{
    this.router.navigate(['/shopping/pedido/' + this.dh.IdPedido]);
  }
  goChat(qnick: any) :void{

    this.tmaService.paginaAnterior = 'me/notificacoes';
    this.router.navigate(['/me/i/' + qnick]);
  }

  autorizarPro() :void{
    //chamada autorizando o pro a ter os dados

    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      idpro: this.dh.IdProfissional
    };
    this.hideCL = false;
    //var dadosU = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&idpaciente=' + this.idPaciente;
    this.tmaService.aceitePro(customParams).subscribe((qRes) => {
      this.hideCL = true;
      console.log(qRes);
      if (qRes['res'] == 'done') {
        const aceiteDone = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Operação realizada com sucesso", tituloAlerta: "Autorizado", iconAlerta: '' }
        })
      }
      else {
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Ocorreu um erro ao realizar o pedido. Tente novamente", iconAlerta: 'warning' }
        })
      }
    },
      (error) => {
        this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
        });
      })

  }


  goTreino(idplano: any):void{
    this.tmaService.gUrlAnterior = '/me/notificacao/' + this.idNotificacao;
    this.router.navigate(['/me/fichatreino/' + idplano]);
  } 

  goPublicacao() :void{
    this.tmaService.gUrlAnterior = '/me/notificacao/' + this.idNotificacao;
    this.router.navigate(['/me/post/' + this.tmaService.hcNomeUsuario + '/' + this.dh.IdPublicacao]);
  }

  goPerfil(nickusuario: any) :void{
    this.router.navigate(['/' + nickusuario]);
  }



  
  goGerenciarND(idplano: any) :void{
    this.tmaService.gUrlAnterior = '/me/notificacao/' + this.idNotificacao;
    var qds = new Date().getDay();
    var diahj = moment(new Date()).format("DD/MM/YYYY");
    this.router.navigate(['me/cardapio/' + idplano + '/' + qds + '/' + diahj.replace(/\//g,'-') ]);
  }


  goAutorizarT(nickusuario: any) :void{
    this.hideCL = false;
        let customParams = {
            //lista: localStorage.getItem('turboCart'),
            nomeusuario: nickusuario,
            email: this.tmaService.hcEmail,
            senha: this.tmaService.hcSenha,
        };
        this.tmaService.autorizarTorcedor(customParams).subscribe((qRes) => {
            this.hideCL = true;
            console.log(qRes);
            if (qRes['res'] == 'done') {
              this.voltar();
            }
            else {
                const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                    disableClose: true,
                    data: { tituloAlerta: "Aviso", textoAlerta: "Ocorreu um erro ao realizar esta operação Tente novamente", iconAlerta: 'warning' }
                })
            }
        },
            (error) => {
                this.hideCL = true;
                const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                    disableClose: true,
                    data: { tituloAlerta: "Aviso", textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
                });
            })
  }
  


  goAtivarND(idplano: any) :void{
    this.hideCL = false;
        let customParams = {
            email: this.tmaService.hcEmail,
            senha: this.tmaService.hcSenha,
            idplano: idplano,
            idnotificacao: this.idNotificacao 
        };
        this.tmaService.ativarTodasND(customParams).subscribe((qRes) => {
            this.hideCL = true;
            console.log(qRes);
            if (qRes['res'] == 'done') {
              
              const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                disableClose: true,
                data: { tituloAlerta: "Pronto", textoAlerta: "As notificações desse plano alimentar foram ativadas com sucesso", iconAlerta: '' }
            })
            }
            else {
                const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                    disableClose: true,
                    data: { tituloAlerta: "Aviso", textoAlerta: "Ocorreu um erro ao realizar esta operação Tente novamente", iconAlerta: 'warning' }
                })
            }
        },
            (error) => {
                this.hideCL = true;
                const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                    disableClose: true,
                    data: { tituloAlerta: "Aviso", textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
                });
            })
  }


  voltar() :void{
    //this._location.back();
    this.router.navigate(['/me/notificacoes']);
  }
}
